import { useCallback, useEffect, useRef, useState } from "react";

import { useGlobalContext } from "../Context/GlobalContext";

export const useDriverTracking = (taskId, enabled) => {
  const { packkyApi } = useGlobalContext();

  const [driverData, setDriverData] = useState(null);
  const [driverPosition, setDriverPosition] = useState(null);
  const [remainingTime, setRemainingTime] = useState(null);
  const [totalTime, setTotalTime] = useState(null);
  const [acknowledgeTime, setAcknowledgeTime] = useState(null);

  const fetchedRef = useRef(false);

  // =====================================================
  // GET DRIVER DETAILS
  // =====================================================

  const fetchDriver = useCallback(async () => {
    if (!taskId) {
      return null;
    }

    try {
      const payload = {
        taskId: String(taskId),
      };

      const res = await packkyApi.post(
        "/api/DriverTracker/v1.0/getDeliveryPartnerDetails",
        payload,
      );

      if (res?.data?.responseCode !== "00") {
        return res?.data;
      }

      const row = res?.data?.data;

      if (!row) {
        return res?.data;
      }

      // =====================================================
      // DRIVER DETAILS
      // =====================================================

      setDriverData({
        name: row?.driver_name || "",
        phone: row?.diver_mobile_number || "",
        image: row?.driver_image || "",
        driverID: row?._driverCode || null,
      });

      // =====================================================
      // DRIVER LOCATION
      // =====================================================

      if (row?.drvier_latitude != null && row?.driver_longitude != null) {
        const latitude = Number(row.drvier_latitude);

        const longitude = Number(row.driver_longitude);

        if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
          setDriverPosition([latitude, longitude]);
        }
      }

      // =====================================================
      // DRIVER TIME DETAILS
      // =====================================================

      setRemainingTime(
        row?.remaining_time != null ? Number(row.remaining_time) : null,
      );

      setTotalTime(row?.total_time != null ? Number(row.total_time) : null);

      setAcknowledgeTime(row?._acknowledgeTime || null);

      console.log("DRIVER ID:", row?._driverCode);

      console.log("DRIVER DATA FETCHED SUCCESSFULLY");

      return res?.data;
    } catch (error) {
      console.error("GET DRIVER DETAILS ERROR:", error);

      return null;
    }
  }, [taskId, packkyApi]);

  // =====================================================
  // FIRST FETCH WHEN DRIVER BECOMES ACTIVE
  // =====================================================

  useEffect(() => {
    if (!enabled) {
      fetchedRef.current = false;

      setDriverData(null);
      setDriverPosition(null);
      setRemainingTime(null);
      setTotalTime(null);
      setAcknowledgeTime(null);

      return;
    }

    if (fetchedRef.current) {
      return;
    }

    fetchedRef.current = true;

    fetchDriver();
  }, [enabled, fetchDriver]);

  // =====================================================
  // RESET FETCH FLAG WHEN TASK CHANGES
  // =====================================================

  useEffect(() => {
    fetchedRef.current = false;
  }, [taskId]);

  // =====================================================
  // RETURN
  // =====================================================

  return {
    driverData,
    driverPosition,
    remainingTime,
    totalTime,
    acknowledgeTime,
    refetchDriver: fetchDriver,
  };
};
